import React from 'react';
const DynaSpan = (props) => {
    if (props.link !== undefined && props.link === true) {
        return (
            <a className="externalLink" href="https://www.dynastripes.xyz/" target="_blank" rel="noreferrer">
                <span className="dyna">DynaStripes</span>
            </a>
        );

    } else {
        return (
            <span className="dyna">DynaStripes</span>
        );
    }
}

export default DynaSpan;